import { ClientHybrid } from '@/models/client.model';
import { BinderService } from '@/services/api/binder.service';
import { ClientService } from '@/services/api/client.service';
import { CommonModule, NgIf } from '@angular/common';
import { Component, effect, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { DocDataService } from 'src/app/services/app/doc-data.service';
import { FluidModule } from 'primeng/fluid';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-signature-clients',
    imports: [TagModule, SkeletonModule, CommonModule, SelectModule, MenuModule, ButtonModule, RippleModule, FormsModule, FluidModule],
    template: `

<div class="flex flex-col gap-4 card mt-2">
      <div class="info-action-row">
        <div class="ml-2 flex w-full">
          <i class="pi pi-user" style="font-size: 2.5rem"></i>
            <div class="ml-3">
              <span class="block text-900 font-medium mb-1">{{name}}</span>
              <div class="text-400">{{subtitle}}</div>
            </div>
        </div>
        <p-fluid>
        <div class="flex flex-col md:flex-row justify-end">
            <div class="flex flex-col gap-2 w-full">
                    <div class="grid grid-cols-12 gap-2">
                        <span class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0 justify-end">Email</span>
                        <div class="col-span-12 md:col-span-9">
                        <p-select [(ngModel)]="selectedEmail" optionLabel="email" optionValue="email"
                        [disabled]="inputDisabled"
                        [options]="emailItems" placeholder="Select an Email" (onChange)="updateEmail($event.value)">
                        </p-select>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-2">
                        <span class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0 justify-end">Mode</span>
                        <div class="col-span-12 md:col-span-9">
                        <p-select id="mode" [(ngModel)]="mode" optionLabel="label" optionValue="value"
                        [disabled]="modeDisabled"
            [options]="modes" placeholder="Select a Signature Mode" (onChange)="updateMode($event.value)">
          </p-select>
                        </div>
                    </div>
                </div>
        </div>
    </p-fluid>
      </div>
    </div>
    `,
    styles: `

.info-action-row {
    display: flex;
    justify-content: space-between;
    align-items: center; /* This will vertically center align the items */
  }

.action-row {
    display: flex;
    justify-content: flex-end; /* Align items to the left */
  }
  
  .action-item {
    margin-right: 5px;
    margin-top: 5px;
    margin-bottom: 5px;;
  }
    `
})
export class SignatureClientsComponent {
  modes = [ {label: 'Email', value: 'email'}, {label: 'In-Person', value: 'in-person'}];
  @Input() mode = 'email';
  @Input() modeDisabled = false;
  @Input() inputDisabled = false;
  @Input() emailItems!: MenuItem[];
  @Input() selectedEmail: string | null = null;
  @Input() name!: string;
  @Input() subtitle!: string;
  @Output() modeChange = new EventEmitter<string>();
  @Output() emailChange = new EventEmitter<string>();
  combinedNames = '';

  constructor(
    public currentBinderService: BinderService
  ) {
  }

  updateEmail(email:string){
    this.emailChange.emit(email);
  }

  updateMode(mode:string){
    this.modeChange.emit(mode);
  }

}
